import { Panel } from "components/panels";
import React from "react";

interface Props {
  linkedItems: server.dto.LinkedItemCount[]
  config: server.dto.LinkedItemCountPanelConfig
}

const LinkedItems = (props: Props) => {
  if (props.linkedItems.length === 0) {
    return null;
  }

  return <Panel
    panelClassName="s1_related-feature-panel"
    title={props.config.headerLabel}
  >
    <div className="s1-linked-items-row gap-mini flex-column">
      {props.linkedItems.map(linkedItem => <a style={{ textDecoration: "none" }} className="hoverable flex" href={linkedItem.url} key={linkedItem.label}>
        <div className="grow1">
          {linkedItem.label}
        </div>
        <div>
          {linkedItem.count}
        </div>
      </a>)}
    </div>
  </Panel>;
};

export default LinkedItems;